import { Skeleton } from '@/components/ui/skeleton';
import { MasterClassCard } from './MasterClassCard';
import type { Serie } from '@/types/masterclass';

interface MasterClassGridProps {
  series: Serie[];
  loading: boolean;
  onOpenSerie?: (serie: Serie) => void;
}

export function MasterClassGrid({ series, loading, onOpenSerie }: MasterClassGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-8">
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={i} className="space-y-3">
            <Skeleton className="aspect-video rounded-2xl" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-full" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-8">
      {series.map((serie) => (
        <MasterClassCard 
          key={serie.id} 
          serie={serie}
          onOpenSerie={onOpenSerie}
        />
      ))}
    </div>
  );
}
